var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { CircularProgress, TextField, Tooltip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import styles from '../style/common.module.css';
export const AddTextField = (props) => {
    const [value, setValue] = useState('');
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { onSubmit, textEditLabel, rows, maxLength, editMinWidth, addIcon, allowEmpty, hoverText } = props;
    const inputRef = useRef(null);
    const isMultiline = rows != undefined && rows > 1;
    useEffect(() => {
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && open) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(value.length, value.length);
        }
    }, [open]);
    useEffect(() => {
        setValue(props.initialValue || '');
    }, [props.initialValue]);
    const cancel = () => __awaiter(void 0, void 0, void 0, function* () {
        setOpen(false);
        setValue(props.initialValue || '');
    });
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        setOpen(false);
        setLoading(true);
        try {
            if (allowEmpty || value.length != 0) {
                yield onSubmit(value);
            }
        }
        finally {
            setLoading(false);
            if (!props.initialValue) {
                setValue('');
            }
        }
    });
    return (_jsxs("div", { children: [loading && _jsx(CircularProgress, { sx: { mr: '2px', color: '#007ca3', verticalAlign: 'middle' }, size: 18, color: "inherit" }), !loading && !open && (_jsx(Tooltip, { title: hoverText && _jsx("span", { style: { whiteSpace: 'pre-wrap' }, children: hoverText }), children: _jsx("div", { className: styles.centered, style: { cursor: 'pointer' }, onClick: () => {
                        setOpen(true);
                    }, children: addIcon }) })), open && (_jsxs("div", { children: [_jsx(TextField, { sx: { mr: 1, mt: 1, minWidth: editMinWidth }, size: "small", inputRef: inputRef, value: value, maxRows: rows || 1, multiline: isMultiline, inputProps: {
                            maxLength: maxLength || 1024,
                        }, onBlur: e => {
                            cancel();
                        }, onChange: e => setValue(e.target.value), onKeyDown: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            if (e.key == 'Escape') {
                                cancel();
                            }
                            if (e.key == 'Enter' && !isMultiline) {
                                submit();
                            }
                        }), required: true, label: textEditLabel, variant: "outlined" }), isMultiline && (_jsxs("div", { style: { display: 'flex', alignContent: 'space-between', marginTop: '2px' }, children: [_jsx("div", { style: { flexGrow: 5 } }), _jsx("div", { children: _jsx(DoneIcon, { cursor: "pointer", color: "success", onMouseDown: e => {
                                        // This is to make sure onBlur doesn't take precedence over clicking this button
                                        e.preventDefault();
                                    }, onClick: () => submit() }) })] }))] }))] }));
};
